import { useState } from "react";
import { DirectoryImportPanel } from "../components/DirectoryImportPanel";
import { HotFolderPanel } from "../components/HotFolderPanel";
import { S3ImportPanel } from "../components/S3ImportPanel";
import { EmailIngestionPanel } from "../components/EmailIngestionPanel";
import "../admin.css";

const TABS = ["Directory Import", "Hot Folders", "S3 / R2 Import", "Email Ingestion"] as const;
type Tab = typeof TABS[number];

export function InputChannelsPage() {
  const [activeTab, setActiveTab] = useState<Tab>("Directory Import");

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1 className="admin-title">Input Channels</h1>
      </div>

      <div className="tab-bar">
        {TABS.map((tab) => (
          <button
            key={tab}
            className={`tab-btn ${activeTab === tab ? "tab-btn--active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="tab-content">
        {activeTab === "Directory Import" && <DirectoryImportPanel />}
        {activeTab === "Hot Folders" && <HotFolderPanel />}
        {activeTab === "S3 / R2 Import" && <S3ImportPanel />}
        {activeTab === "Email Ingestion" && <EmailIngestionPanel />}
      </div>
    </div>
  );
}
